import {
  FINDING_SEVERITY_RANK,
  PLATFORM_NOTIFICATION_ACTION_TYPE,
  type FindingSeverityRankKey,
  type PlatformNotificationActionType,
} from '@terra/shared-contracts-notification-center';

const SEVERITY_LABEL_BY_RANK = Object.fromEntries(
  Object.entries(FINDING_SEVERITY_RANK).map(([label, rank]) => [
    String(rank),
    label,
  ]),
) as Record<string, FindingSeverityRankKey>;

export const getActionTranslationKey = ({
  type,
}: {
  type: PlatformNotificationActionType;
}): string => {
  const segments = type.split('.');
  return segments[segments.length - 1] ?? type;
};

export const getSeverityFromRank = ({
  severityRank,
}: {
  severityRank: number | null;
}): FindingSeverityRankKey | undefined =>
  severityRank != null
    ? SEVERITY_LABEL_BY_RANK[String(severityRank)]
    : undefined;

export const isSignalImportAction = ({
  type,
}: {
  type: PlatformNotificationActionType;
}): boolean =>
  type === PLATFORM_NOTIFICATION_ACTION_TYPE.SIGNAL_IMPORT_COMPLETED ||
  type === PLATFORM_NOTIFICATION_ACTION_TYPE.BUG_BOUNTY_SIGNAL_IMPORT_SUMMARY;

export const getSignalImportActionCounts = ({
  context,
}: {
  context: Record<string, unknown> | null | undefined;
}): {
  batchId: string | null;
  importedSignalCount: number;
  failedCount: number;
} => {
  const importedSignalCount = Math.max(
    0,
    Number(context?.importedSignalCount ?? context?.signalsCreated ?? 0),
  );
  const failedCount = Math.max(0, Number(context?.failedCount ?? 0));
  const batchId = typeof context?.batchId === 'string' ? context.batchId : null;

  return {
    batchId,
    importedSignalCount,
    failedCount,
  };
};
